import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {
  @Input() title: string ='';
  @Input() messagebody: string ='';
  @Input() btnOk: string ='';
  @Input() btnCancel: string ='';
  constructor(private activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
  public cancel() {
    this.activeModal.close(false);
  }

  public ok() {
    this.activeModal.close(true);
  }

  public Close() {
    this.activeModal.dismiss();
  }

}
